export default "__VITE_ASSET__XKGswiA0__"